import sum from "lodash/sum";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  warehouseUsers: [],
  warehouseUser: null,
  warehouseAllUser: [],
};

const slice = createSlice({
  name: "warehouseUser",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getwarehouseUsersSuccess(state, action) {
      state.isLoading = false;
      state.warehouseUsers = action.payload;
    },

    getwarehouseUserSuccess(state, action) {
      state.isLoading = false;
      state.warehouseUser = action.payload;
    },
    getwarehouseAllUserSuccess(state, action) {
      state.isLoading = false;
      state.warehouseAllUser = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

export function getWarehouseUsers(warehouseId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/warehouseUser?warehouseId=${warehouseId}&limit=${9999999999999}`
      );
      dispatch(slice.actions.getwarehouseUsersSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



// ----------------------------------------------------------------------

export function getwarehouseUser(warehouseUserId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/warehouseUser/${warehouseUserId}`
      );
      dispatch(slice.actions.getwarehouseUserSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllUsersOfwarehouse(warehouseId, getToken) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${backendUrl}/warehouseUsers/getAllwarehouseUsers?&limit=${9999999999999}`,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
          params: {
            warehouse: warehouseId,
          },
        }
      );
      dispatch(slice.actions.getwarehouseAllUserSuccess(response.data?.results));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
